import React, { useEffect, useState } from "react";
import PublishButton from "../publish/publishButton";
import { SaveChangesPopup } from "../Home/savePopup";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import BannerUpload from "./bannerUpload";

const Banner = () => {
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [togglePop, setTogglePop] = useState(false);
  const [activeSlideId, setActiveSlideId] = useState(1);
  const [image, setImage] = useState(null);
  const openPopUp = (slideId) => {
    setActiveSlideId(slideId);
    setTogglePop(true);
    setToggleSwitch(!toggleSwitch);
  };
  const closePopUp = () => {
    setActiveSlideId(1);
    setTogglePop(false);
  };
  async function handleSwitch(e, activeSlideId) {
    // e.stopPropagation();
    try {
      const token = sessionStorage.getItem("token");
      const config = {
        method: "PUT",
        mode: "cors",
        url: `${API_BASE_URL}/updataprogrameData/${1}`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        data: { Published: toggleSwitch },
      };
      const response = await axios(config);
      console.log(response?.data?.status);
      if (response?.data?.status) {
        toast.success("Published Successfully");
      }
    } catch (e) {
      console.log("Error:", e);
    }
  }
  const onSaveChanges = async () => {
    // Close the popup first
    closePopUp();
    // Proceed with saving changes
    if (activeSlideId !== null) {
      await handleSwitch(activeSlideId);
    }
  };
  const getAboutData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getprogramData`);
      setImage(response.data.data?.Photo);
      setActiveSlideId(response.data.data?.id);
      setToggleSwitch(response.data.data?.Published);
    } catch (e) {
      console.log("err", e);
    }
  };
  useEffect(() => {
    getAboutData();
  }, []);
  return (
    <>
      <div className="bg-[#F1F5F9] bg-cover ">
        <div className="flex flex-row font-['Roboto']">
          <div className="flex flex-col">
            <h1
              className="lg:ml-[4rem]   font-['Roboto'] font-semibold lg:text-[40px] 2xl:text-4xl text-[#1A2338]"
              style={{ lineHeight: "78px" }}
            >
              Programs
            </h1>
            <p className="font-bold lg:text-[24px] 2xl:text-xl text-sm  lg:ml-[4rem] text-[#1A2338B2] ">
              Banner image
            </p>
          </div>
        </div>
        <div className="font-['Roboto'] flex flex-col  rounded-3xl 2xl:mt-[34px]  bg-[#FFFFFF] w-[30rem] h-[400px]  lg:ml-[3rem]">
          <div className="flex flex-row items-center">
            <h1 className="mb-[13px] ml-[3rem] pt-[26px] font-bold text-sm text-left text-[#1A233899]">
              Image
            </h1>
            <div className="ml-auto">
              <PublishButton
                isPublished={toggleSwitch}
                openPopUp={() => openPopUp(1)}
                slideId={1}
              />
            </div>
          </div>
          <SaveChangesPopup
            open={togglePop}
            onSave={onSaveChanges}
            onClose={closePopUp}
          />
          <BannerUpload
            selectedImage={image}
            setImage={setImage}
            setToggleSwitch={setToggleSwitch}
            setActiveSlideId={setActiveSlideId}
            toggleSwitch={toggleSwitch}
            slideId={1}
          />
        </div>
      </div>
    </>
  );
};

export default Banner;
